export default {
  API_URL: process.env.VUE_APP_API_URL,
  ENVIRONMENT: process.env.NODE_ENV ? process.env.NODE_ENV : 'development',
};
